// @ts-nocheck
import {
  FormulaHelpers,
  WildCard,
  Types,
  FormulaError,
} from 'fast-formula-parser';

const H = FormulaHelpers;

export const VLookUp = (lookupValue, tableArray, colIndexNum, rangeLookup) => {
  // preserve type of lookupValue
  // console.log("vlookup ")
  lookupValue = H.accept(lookupValue);
  try {
    tableArray = H.accept(tableArray, Types.ARRAY, undefined, false);
  } catch (e) {
    // catch #VALUE! and throw #N/A
    if (e instanceof FormulaError) throw FormulaError.NA;
    throw e;
  }
  colIndexNum = H.accept(colIndexNum, Types.NUMBER);
  rangeLookup = H.accept(rangeLookup, Types.BOOLEAN, true);

  // check if colIndexNum out of bound
  if (colIndexNum < 1) throw FormulaError.VALUE;
  if (tableArray[0][colIndexNum - 1] === undefined) throw FormulaError.REF;

  const lookupType = typeof lookupValue; // 'number', 'string', 'boolean'

  // approximate lookup (assume the array is sorted)
  if (rangeLookup) {
    let prevValue =
      lookupType === typeof tableArray[0][0] ? tableArray[0][0] : null;
    for (let i = 1; i < tableArray.length; i++) {
      const currRow = tableArray[i];
      const currValue = tableArray[i][0];
      const type = typeof currValue;
      // skip the value if type does not match
      if (type !== lookupType) continue;
      // if the previous two values are greater than lookup value, throw #N/A
      if (prevValue > lookupValue && currValue > lookupValue) {
        throw FormulaError.NA;
      }
      if (currValue === lookupValue) return currRow[colIndexNum - 1];
      // if previous value <= lookup value and current value > lookup value
      if (
        prevValue != null &&
        currValue > lookupValue &&
        prevValue <= lookupValue
      ) {
        return tableArray[i - 1][colIndexNum - 1];
      }
      prevValue = currValue;
    }
    if (prevValue == null) throw FormulaError.NA;
    return prevValue;
  }
  // exact lookup with wildcard support
  else {
    let index = -1;
    if (WildCard.isWildCard(lookupValue)) {
      index = tableArray.findIndex((currRow) => {
        return WildCard.toRegex(lookupValue, 'i').test(currRow[0]);
      });
    } else {
      index = tableArray.findIndex((currRow) => {
        // console.log("currRow[0", currRow[0], "lookupValue", lookupValue)
        return currRow[0] === lookupValue;
      });
    }
    // the exact match is not found
    if (index === -1) throw FormulaError.NA;
    return tableArray[index][colIndexNum - 1];
  }
};
export const HLookUp = (lookupValue, tableArray, rowIndexNum, rangeLookup) => {
  // preserve type of lookupValue
  lookupValue = H.accept(lookupValue);
  try {
    tableArray = H.accept(tableArray, Types.ARRAY, undefined, false);
  } catch (e) {
    // catch #VALUE! and throw #N/A
    if (e instanceof FormulaError) throw FormulaError.NA;
    throw e;
  }
  rowIndexNum = H.accept(rowIndexNum, Types.NUMBER);
  rangeLookup = H.accept(rangeLookup, Types.BOOLEAN, true);

  // check if rowIndexNum out of bound
  if (rowIndexNum < 1) throw FormulaError.VALUE;
  if (tableArray[rowIndexNum - 1] === undefined) throw FormulaError.REF;

  const lookupType = typeof lookupValue; // 'number', 'string', 'boolean'

  // approximate lookup (assume the array is sorted)
  if (rangeLookup) {
    let prevValue =
      lookupType === typeof tableArray[0][0] ? tableArray[0][0] : null;
    for (let i = 1; i < tableArray[0].length; i++) {
      const currValue = tableArray[0][i];
      const type = typeof currValue;
      // skip the value if type does not match
      if (type !== lookupType) continue;
      // if the previous two values are greater than lookup value, throw #N/A
      if (prevValue > lookupValue && currValue > lookupValue) {
        throw FormulaError.NA;
      }
      if (currValue === lookupValue) return tableArray[rowIndexNum - 1][i];
      // if previous value <= lookup value and current value > lookup value
      if (
        prevValue != null &&
        currValue > lookupValue &&
        prevValue <= lookupValue
      ) {
        return tableArray[rowIndexNum - 1][i - 1];
      }
      prevValue = currValue;
    }
    if (prevValue == null) throw FormulaError.NA;
    return prevValue;
  }
  // exact lookup with wildcard support
  else {
    let index = -1;
    if (WildCard.isWildCard(lookupValue)) {
      index = tableArray[0].findIndex((item) => {
        return WildCard.toRegex(lookupValue, 'i').test(item);
      });
    } else {
      index = tableArray[0].findIndex((item) => {
        return item === lookupValue;
      });
    }
    // the exact match is not found
    if (index === -1) throw FormulaError.NA;
    return tableArray[rowIndexNum - 1][index];
  }
};
